import Container from "../../components/ui/Container";
import React from "react";
import Heading from "../../components/NewUi/heading/Heading";
import Card from "../../components/NewUi/featureCard/Card";
import RetroCardSection from "../../components/ui/RetroCardSection";
import Waves from "../../components/ui/Waves";
// import auth from '../../services/authServices'
const FeatureSection = () => {
    // const token = auth.getToken();

    return (
        <div className="">
            <section className=" min-h-screen px-5 md:px-20 md:h-fit relative overflow-hidden flex justify-center items-start md:items-start xl:items-start ">
                <Container className="h-fit relative z-10 pb-10 md:pb-0 space-y-4 flex flex-col md:flex-row gap-5 md:gap-10">
                    <div className="basis-full md:basis-1/2">
                        <div className="w-full">
                            <Heading title="لـــــــــيه سحــــــابة" />
                        </div>
                        <div className="pt-4 text-center md:text-right text-xl md:text-2xl w-[60%] text-gray-600 dark:text-gray-200 smooth space-y-2 font-lama">
                            في سحابة، إحنا عارفين إن المذاكرة ممكن تكون صعبة، عشان كده وفرنالك تجربة
                            تعليمية مختلفة وسهلة تخليك تتفوق بدون تعقيد!
                            <br />
                            <br />
                            <span className="pt-10">
                                مع سحابة، المذاكرة هتبقى أسهل وأمتع، ونجاحك مضمون!
                            </span>
                        </div>
                    </div>
                    <div className="basis-full md:basis-1/2">
                        <RetroCardSection />
                    </div>
                </Container>
            </section>
            <div className="relative min-h-[30vh] bg-moonBlue-400 dark:bg-moonBlue-900 smooth flex-col">
                <Waves className="fill-primary-container transform -translate-y-1/4 scale-y-[.5] rotate-180 z-10 absolute right-0 top-0 left-0 w-full" />
                <Waves className="fill-primary-container transform translate-y-1/4 scale-y-[.5] z-10 absolute right-0 bottom-0 left-0 w-full" />
            </div>
        </div>
    );
};

export default FeatureSection;
